module.exports = __webpack_public_path__ + "img/sy_bg.2bade79f.png";